import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import DashboardAdmin from "./DashboardAdmin";
import EditIcon from "@mui/icons-material/Edit";
import Fab from "@mui/material/Fab";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import {DialogContent, TextField} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import {DataGrid} from "@mui/x-data-grid";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import Chip from "@mui/material/Chip";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from "@mui/material/Checkbox";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import {GadgetDashboard} from "../components/GadgetDashboard";
import {StyledEngineProvider} from "@mui/material/styles";
import { styled } from '@mui/material/styles';
import PipeAdmin from "./PipeAdmin";
import LinkAdmin from './LinkAdmin';

export default function AdminTabLayout (props) {
    const [value, setValue] = React.useState(0);
    const [open, setOpen] = React.useState(false);
    const { uiGrpNo, userNo, userGrpNo } = props;

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleClose = () => {
        setOpen(false);
    };
    const handleClickOpen = () => {
        setOpen(true);
    };
    const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
        ({ theme }) => ({
            textTransform: 'none',
            fontWeight: theme.typography.fontWeightRegular,
            fontSize: theme.typography.pxToRem(15),
            marginRight: theme.spacing(1),
            color: 'rgba(255, 255, 255, 1)',
            '&.Mui-selected': {
                color: '#ffea00',
            },
            '&.Mui-focusVisible': {
                backgroundColor: 'rgba(100, 95, 228, 0.32)',
            },
        }),
    );


    return (
        <StyledEngineProvider injectFirst>
            <Fab className="dashboard_admin_button" color="primary" variant="extended" onClick={handleClickOpen}>
                <EditIcon  sx={{ mr: 1 }}/>
                ADMIN
            </Fab>
            {/* 관리자 페이지 다이어로그 */}
            <Dialog onClose={handleClose} open={open} fullWidth={true} maxWidth={'xl'}>
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs  value={value} onChange={handleChange} aria-label="basic tabs example">
                                <StyledTab sx={{color:'white'}} label="대시보드관리" {...a11yProps(0)} />
                                <StyledTab label="배관관리" {...a11yProps(1)} />
                                <StyledTab label="메뉴 ↔ 대시보드 링크연결" {...a11yProps(2)} />
                            </Tabs>
                        </Box>
                        <TabPanel value={value} index={0}>
                            <DashboardAdmin userGrpNo={userGrpNo}/>
                        </TabPanel>
                        <TabPanel value={value} index={1}>
                            <PipeAdmin/>
                        </TabPanel>
                        <TabPanel value={value} index={2}>
                            <LinkAdmin userGrpNo={userGrpNo} />
                        </TabPanel>
                    </Box>
                </DialogContent>
            </Dialog>
        </StyledEngineProvider>

    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};